module.exports = __webpack_public_path__ + "assets/img/8ae0075e8d581af55b1c092065321704.png";